<template>
  <div class="sidebarMain">
    <el-scrollbar
      wrap-class="scrollbar-wrapper"
      class="sidebar-container">
      <el-menu
        :show-timeout="200"
        :default-active="pathActive"
        :unique-opened="true"
        :collapse="isCollapse"
        mode="vertical"
        background-color="#fff"
        text-color="#6d6d6d"
        active-text-color="#ec5124">

        <template v-for="(item) in menu">
          <div v-if="item.isLogo"
            :key="item.name + Math.random()"
            class="logo_div">工单系统</div>

          <template v-else>
            <el-menu-item
              :index="item.href"
              :title="item.name"
              :key="item.name + Math.random()"
              @click="onClickMenu(item)"
              class="menu-item">
              <i :class="item.icon"></i>
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
          </template>
        </template>

        <!-- class hide-if-not-system-user 用于非后台用户隐藏设置 -->
        <el-menu-item v-permission="'TICKET_MORE_VIEW_AUTH'"
          class="hide-if-not-system-user el-submenu-2"
          title="设置"
          key="setting"
          index="999"
          @click="$router.push('/ticket-vue/setting')">
          <i class="el-icon-s-tools"></i>
          <span slot="title">工单设置</span>
        </el-menu-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SideBarItem from './SideBarItem';
import { compile } from 'path-to-regexp';
import path from 'path';
import { isExternal } from '@/assets/utils/JiachenPanUtil';
import MenuLink from './MenuLink';

// 左侧顶级菜单
var top_left_menu = [{
  isLogo : true,
}, {
  name : '主页',
  icon : 'el-icon-s-home',
  href : '/ticket-vue/ticket/view?ticketType=3'
}, {
  name : 'Dashboard',
  icon : 'el-icon-s-grid',
  href : '/ticket-vue/ticket/view?ticketType=8'
}, {
  name : '工单视图',
  icon : 'el-icon-s-unfold',
  href : '/ticket-vue/ticket/view?ticketType=3'
}, {
  name : '项目工单',
  icon : 'el-icon-data-line',
  href : '/ticket-vue/ticket/view?ticketType=98'
}, {
  name : '用户',
  icon : 'el-icon-user-solid',
  route : '/ticket-vue/ticket/user-manage'
}, {
  name : '我的成员',
  icon : 'el-icon-user',
  route : '/ticket-vue/ticket/user-staff'
}, {
  name : '统计',
  icon : 'el-icon-s-data',
  route : '/ticket-vue/ticket/report'
}, {
  name : '动态',
  icon : 'el-icon-notebook-2',
  href : '/ticket-vue/ticket/view?ticketType=99'
}];

export default {
  name : 'SideBar',

  data() {
    return {
      menu:[],
      list: [], //菜单权限筛选后
      pathActive : ''
    }
  },

  components: { SideBarItem , MenuLink},

  props: {
    basePath: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters([
      'sidebar'
    ]),

    routes() {
      return this.$router.options.routes
    },

    isCollapse() {
      return !this.sidebar.opened
    }
  },

  methods: {
    onClickMenu(item) {
      // href
      if ( !!item.href ) {
        location.href = item.href;
        return;
      }

      // route
      if ( !!item.route ) {
        this.$router.push(item.route);
      }
    },

    resolvePath(routePath) {
      if(this.isExternalLink(routePath)) {
        return routePath
      }

      return path.resolve(this.basePath, routePath)
    },

    isExternalLink(routePath) {
      return isExternal(routePath)
    },

    initMenu() {
      this.menu = top_left_menu;
    }
  },

  mounted() {
    this.initMenu();
  }
}
</script>

<style>
  /* 先隐藏 如果是后台用户 再显示出来 */
  .hide-if-not-system-user {
    display: none;
  }

  .el-submenu-2 {
    position:absolute;
    bottom:0;
    width:100%;
    padding-bottom:20px;
  }

  .el-tooltip {
    padding-left: 5px!important;
  }

  .menu-item span {
    color: #6d6d6d;
  }

  .menu-item i {
    color: #6d6d6d!important;
  }

  .logo_div {
    font-size:40px;
    width:100%;
    height:61px;
    color: #b3adad;
    background: #fbfbfb;
    padding: 0 18px;
    border-bottom: solid 2px #e6e6e6;
  }

  .el-menu--collapse .logo_div {
    font-size:35px;
    padding: 4px 0;
  }

  .el-menu--vertical .el-menu {
      overflow-y: scroll;
      max-height: 800px;
  }
  .el-menu--vertical .el-menu::-webkit-scrollbar {/*滚动条整体样式*/
      width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
  }
  .el-menu--vertical .el-menu::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.3);
      background: rgba(0,0,0,0.3);
  }
  .el-menu--vertical .el-menu::-webkit-scrollbar-track {/*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px #dedee3;
      border-radius: 0;
      background: #dedee3;
  }
  .notblue {
    color: #6d6d6d;
  }
  .notblue:focus, .notblue:hover {
    color: #ec5124;
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/SideBar.vue